export enum UserCategoryEnums {
  BUSINESS = 'business',
  INDIVIDUAL = 'individual',
}
export enum RoleEnums {
  PORTAL_ADMIN = 'super_admin',
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  STAFF = 'staff',
}
